import { render, staticRenderFns } from "./monitorPoint.vue?vue&type=template&id=32a97d58&scoped=true&"
import script from "./monitorPoint.vue?vue&type=script&lang=js&"
export * from "./monitorPoint.vue?vue&type=script&lang=js&"
import style0 from "./monitorPoint.vue?vue&type=style&index=0&id=32a97d58&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a97d58",
  null
  
)

export default component.exports